import EnvService from './env.service';

export default EnvService;
